// Fonts are bundled rather than fetched from Google. A font CDN sees the IP of
// every visitor on every cold load, which is not a thing a private app for two
// people should be leaking (SPEC §3), and a self-hosted face keeps working
// offline once the app is installed.
import "@fontsource-variable/onest";
import "@fontsource-variable/manrope";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import { StrictMode } from "react";
import { applyTheme } from "./app/theme.js";
import { applyLocale, getLocale } from "./i18n/index.js";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
// Side-effect import: registers the service worker once, before the tree
// mounts, so the update prompt can appear on the sign-in screen too.
import "./pwa/registration";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

/*
 * Applied before the first render.
 *
 * Doing it inside a component means one frame in the wrong theme on every cold
 * start, which is exactly the flash people notice.
 */
try {
  const stored = localStorage.getItem("vmeste.theme");
  if (stored === "light" || stored === "dark") applyTheme(stored);
} catch {
  /* storage unavailable — follow the system, which needs no attribute */
}

/*
 * The language, for the same reason and one more.
 *
 * `applyLocale` puts `lang` on the document — which hyphenation and screen
 * readers both read — and writes the mirror the service worker reads when it
 * has to name a notification with no page open. The store has already worked
 * the choice out at import; this is what makes it visible outside React.
 */
applyLocale(getLocale());

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
